import React, { PureComponent } from 'react' //eslint-disable-line
import Loadable from 'react-loadable'
import { PropTypes } from 'prop-types'
import { renderRoutes } from 'react-router-config'

class PageLoading extends PureComponent {
  componentDidMount() {
    document.querySelector('.dna-preloader').classList.remove('hide')
  }
  componentWillUnmount() {
    document.querySelector('.dna-preloader').classList.add('hide')
  }
  render() {
    return null
  }
}

const Index = Loadable({
  loader: ()=> import('./containers/Home'),
  loading: PageLoading
})

const About = Loadable({
  loader: ()=> import('./containers/About'),
  loading: PageLoading
})

const EULA = Loadable({
  loader: ()=> import('./containers/EULA'),
  loading: PageLoading
})

const Innovation = Loadable({
  loader: ()=> import('./containers/Innovation'),
  loading: PageLoading
})

const Industry = Loadable({
  loader: ()=> import('./containers/Industry'),
  loading: PageLoading
})

const Approach = Loadable({
  loader: ()=> import('./containers/Approach'),
  loading: PageLoading
})

const Platform = Loadable({
  loader: ()=> import('./containers/Platform'),
  loading: PageLoading
})

const Portfolio = Loadable({
  loader: ()=> import('./containers/Portfolio'),
  loading: PageLoading
})

const Contact = Loadable({
  loader: ()=> import('./containers/Contact'),
  loading: PageLoading
})

const Support = Loadable({
  loader: ()=> import('./containers/Support'),
  loading: PageLoading
})

const Liquipel = Loadable({
  loader: ()=> import('./containers/Liquipel'),
  loading: PageLoading
})

const Asher = Loadable({
  loader: ()=> import('./containers/Asher'),
  loading: PageLoading
})

const Ljp = Loadable({
  loader: ()=> import('./containers/Ljp'),
  loading: PageLoading
})

const Carpetpros = Loadable({
  loader: ()=> import('./containers/Carpetpros'),
  loading: PageLoading
})

const HealthAndSafety = Loadable({
  loader: ()=> import('./containers/HealthAndSafety'),
  loading: PageLoading
})

const Amp = Loadable({
  loader: ()=> import('./containers/Amp'),
  loading: PageLoading
})

const Allstock = Loadable({
  loader: ()=> import('./containers/Allstock'),
  loading: PageLoading
})

const CorpoTech = Loadable({
  loader: ()=> import('./containers/CorpoTech'),
  loading: PageLoading
})

const Terms = Loadable({
  loader: ()=> import('./containers/Terms'),
  loading: PageLoading
})

const CCTerms = Loadable({
  loader: ()=> import('./containers/CCTerms'),
  loading: PageLoading
})

const NotFound = Loadable({
  loader: ()=> import('./containers/NotFound'),
  loading: PageLoading
})

const scrollToTop = () => {
  if (document.body.scrollTop !== 0 || document.documentElement.scrollTop !== 0) {
    window.scrollBy(0, -160)
    requestAnimationFrame(scrollToTop)
  }
}
class AppRoot extends PureComponent {
  static childContextTypes = {
    inkDisabled: PropTypes.bool
  }

  componentDidUpdate() {
    scrollToTop()
  }

  getChildContext() {
    return { inkDisabled: true }
  }
  render() {
    const { route } = this.props
    return renderRoutes(route.routes)
  }
}

const routes = [
  {
    component: AppRoot,
    routes: [{
      path: '/',
      component: Index,
      exact: true
    },
    {
      path: '/home',
      component: Index,
      exact: true
    },
    {
      path: '/about',
      component: About,
      exact: true
    },
    {
      path: '/EULA',
      component: EULA,
      exact: true
    },
    {
      path: '/innovation',
      component: Innovation,
      exact: true
    },
    {
      path: '/industry',
      component: Industry,
      exact: true
    },
    {
      path: '/approach',
      component: Approach,
      exact: true
    },
    {
      path: '/platform',
      component: Platform,
      exact: true
    },
    {
      path: '/portfolio',
      component: Portfolio,
      exact: true
    },
    {
      path: '/contact',
      component: Contact,
      exact: true
    },
    {
      path: '/support',
      component: Support,
      exact: true
    },
    {
      path: '/liquipel',
      component: Liquipel,
      exact: true
    },
    {
      path: '/asher',
      component: Asher,
      exact: true
    },
    {
      path: '/ljp',
      component: Ljp,
      exact: true
    },
    {
      path: '/carpetpros',
      component: Carpetpros,
      exact: true
    },
    {
      path: '/healthandsafety',
      component: HealthAndSafety,
      exact: true
    },
    {
      path: '/amp',
      component: Amp,
      exact: true
    },
    {
      path: '/allstock',
      component: Allstock,
      exact: true
    },
    {
      path: '/corporatetech',
      component: CorpoTech,
      exact: true
    },
    {
      path: '/terms',
      component: Terms,
      exact: true
    },
    {
      path: '/ccterms',
      component: CCTerms,
      exact: true
    },
    {
      component: NotFound
    }]
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routes.js